module.exports = __webpack_public_path__ + "static/img/tjwx.c7dce0cc.png";